export const FETCH_SURVEYS_CALL = 'FETCH_SURVEYS_CALL';
export const FETCH_SURVEYS_SUCCESS = 'FETCH_SURVEYS_SUCCESS';
export const FETCH_SURVEYS_FAILURE = 'FETCH_SURVEYS_FAILURE';

export const SELECT_SURVEY = 'SELECT_SURVEY';

export const FETCH_SURVEY_CALL = 'FETCH_SURVEY_CALL';
export const FETCH_SURVEY_SUCCESS = 'FETCH_SURVEY_SUCCESS';
export const FETCH_SURVEY_FAILURE = 'FETCH_SURVEY_FAILURE';